import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-service-utils/lib/checkIfResponseSuccess';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import { ClientItem } from 'owa-mail-store';

function getMessageDetailsResponseShape(): ItemResponseShape {
    return itemResponseShape({
        BaseShape: 'IdOnly',
    });
}

function processResponseMessage(responseMessage: SingleResponseMessage[]): string {
    if (checkIfResponseSuccess(responseMessage[0])) {
        const responseItem = responseMessage[0] as ItemInfoResponseMessage;
        const item = responseItem.Items[0];
        if (item.ExtendedProperty != null && item.ExtendedProperty.length >= 1) {
            return item.ExtendedProperty[0].Value;
        }
    }
    return null;
}

export function loadMessageDetails(item: ClientItem): Promise<string> {
    return getItem(
        [item.ItemId.Id],
        getMessageDetailsResponseShape(),
        'MessageDetails',
        'V2016_06_24',
        item.MailboxInfo?.requestOptions
    ).then(responseMessage => {
        return processResponseMessage(responseMessage);
    });
}
